import { useSearchParams } from 'react-router-dom';

export default function EmailChangeStatus() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  const message = {
    success: "✅ Your email has been updated successfully!",
    failed: "⚠️ We were unable to confirm the email change.",
    error: "🚫 An error occurred during confirmation.",
    missing: "❓ Invalid confirmation link.",
  }[status] || "Unknown response.";

  return (
    <div className="container text-center mt-5">
      <h3>Email Change Confirmation</h3>
      <p>{message}</p>
    </div>
  );
}
